import assessmentReader from '../../store/readHelpers/AssessmentReader';
import uiService from '../../services/UIService';
import backgroundAudioService from '../../services/BackgroundAudioService';
import sessionReader from '../../store/readHelpers/SessionReader';
import { t } from '../../services/i18nService';

const inlineSubHeaderSelector = {
    selectShowDefaultAudioStatus(showControllableAudioStatus, ui) {
        return !showControllableAudioStatus && !!ui.backgroundAudioStarted;
    },

    selectShowControllableAudioPlayingStatus(showControllableAudioStatus, hasPlayingSectionAudio) {
        return showControllableAudioStatus && hasPlayingSectionAudio;
    },

    selectShowControllableAudioNotPlayingStatus(showControllableAudioStatus, hasPlayingSectionAudio) {
        return showControllableAudioStatus && !hasPlayingSectionAudio;
    },

    selectAudioSectionNumber(backgroundAudio, hasPlayingSectionAudio) {
        if (sessionReader.isPaused() && backgroundAudio.recentPlayingAudioId) {
            return backgroundAudioService.getAudioSectionNumber(backgroundAudio.recentPlayingAudioId);
        }

        return hasPlayingSectionAudio
            ? backgroundAudioService.getPlayingAudioSectionNumber(backgroundAudio)
            : assessmentReader.getCurrentSectionNumber();
    },

    selectAudioStatusCaption(showControllableAudioPlayingStatus, showControllableAudioNotPlayingStatus, sectionNumber) {
        if (showControllableAudioPlayingStatus) {
            return t('header.backgroundAudioControl.audioPlaying', { number: sectionNumber });
        }

        if (showControllableAudioNotPlayingStatus) {
            return t('header.backgroundAudioControl.audioNotPlaying', { number: sectionNumber });
        }

        return null;
    },

    selectProps(state) {
        const {
            backgroundAudio,
            remoteOralExam,
            ui,
        } = state;

        const showControllableStatus = uiService.showBackgroundAudioControlButton();
        const hasPlayingSectionAudio = backgroundAudioService.hasPlayingSectionAudio(backgroundAudio);
        const sectionNumber = this.selectAudioSectionNumber(backgroundAudio, hasPlayingSectionAudio);
        const showControllablePlayingStatus = this.selectShowControllableAudioPlayingStatus(showControllableStatus, hasPlayingSectionAudio);
        const showControllableNotPlayingStatus = this.selectShowControllableAudioNotPlayingStatus(showControllableStatus, hasPlayingSectionAudio);
        const audioStatus = ui.backgroundAudioStatus;

        return {
            audioStatusCaption: this.selectAudioStatusCaption(showControllablePlayingStatus, showControllableNotPlayingStatus, sectionNumber),
            showControllableAudioNotPlayingStatus: showControllableNotPlayingStatus,
            showControllableAudioPlayingStatus: showControllablePlayingStatus,
            showDefaultAudioStatus: this.selectShowDefaultAudioStatus(showControllableStatus, ui),
            showLivestreamStatus: sessionReader.supportsLivestream(),
            showRecordingStatus: uiService.showRecordingNotification(remoteOralExam),
            audioStatus,
        };
    },
};

export default inlineSubHeaderSelector;
